export default "__VITE_ASSET__GOvOF2zr__"